import { render, staticRenderFns } from "./UpdateCustomField.vue?vue&type=template&id=f4ebd8f6&scoped=true&"
import script from "./UpdateCustomField.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ebd8f6",
  null
  
)

export default component.exports